<div class="p-4 side" [ngClass]="toggleOpen ? 'open' : 'closed'" style="position: fixed; left: 0px; top: 60px"
  (mouseenter)="toggleOpen = !toggleOpen" (mouseleave)="toggleOpen = !toggleOpen">
  <div class="row justify-content-center my-2 mb-4">
    <i [ngClass]="!toggleOpen ? 'fak fa-bars-close fa-lg' : 'fak fa-bars-open fa-lg'"></i>
  </div>

  <!-- Catálogo -->
  <ng-container *appCan="'catalog:read'">
    <div class="row my-2 justify-content-center">
      <button [ngClass]="!toggleOpen ? 'btn btn-icon btn-icon-closed' : 'btn btn-primary btn-icon-open'"
        routerLink="/catalog" [class.active-link]="checkExact()">
        <i class="fa-solid fa-list-ul fa-lg" style="width: 30px"></i>
        <a style="font-size: 16px; text-transform: capitalize">{{ toggleOpen ? 'Catálogo' : '' }}</a>
      </button>
    </div>
  </ng-container>

  <!-- Histórico (Histórico de Sinalizações do usuário) -->
  <ng-container *appCan="'signaling_history:read'">
    <div class="row justify-content-center my-2">
      <button [ngClass]="!toggleOpen ? 'btn btn-icon btn-icon-closed' : 'btn btn-primary btn-icon-open'"
        routerLink="/catalog/history" [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="active-link">
        <i class="fa-regular fa-diamond-turn-right fa-lg" style="width: 30px"></i>
        <a style="font-size: 16px; text-transform: capitalize">{{ toggleOpen ? 'Histórico' : '' }}</a>
      </button>
    </div>
  </ng-container>

  <!-- Pendências -->
  <ng-container *appCan="'pendencies:read'">
    <div class="row justify-content-center my-2">
      <button [ngClass]="!toggleOpen ? 'btn btn-icon btn-icon-closed' : 'btn btn-primary btn-icon-open'"
        routerLink="/catalog/pendencies" routerLinkActive="active-link">
        <i class="fa-regular fa-pause-circle fa-lg" style="width: 30px"></i>
        <a style="font-size: 16px; text-transform: capitalize">{{ toggleOpen ? 'Pendências' : '' }}</a>
      </button>
    </div>
  </ng-container>

  <!-- Ocorrências -->
  <ng-container *appCan="'occurrences:read'">
    <div class="row justify-content-center my-2">
      <button [ngClass]="!toggleOpen ? 'btn btn-icon btn-icon-closed' : 'btn btn-primary btn-icon-open'"
        routerLink="/catalog/occurrences/display" routerLinkActive="active-link">
        <i class="fa-regular fa-message-exclamation fa-lg" style="width: 30px"></i>
        <a style="font-size: 16px; text-transform: capitalize">{{ toggleOpen ? 'Ocorrências' : '' }}</a>
      </button>
    </div>
  </ng-container>

  <div class="sidebar-footer">
    <img [src]="org?.imageURL ?? 'assets/icons/camera.svg'" class="org-img" />
    <div class="d-flex">
      <span *ngIf="toggleOpen" style="font-size: 11px; line-height: 15px">{{
        org?.name ?? 'Organização não informada'
        }}</span>
    </div>
  </div>
</div>